import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from 'app/modules/translate.module';
import { LayoutModule } from '@monsido/angular-shared-components';
import { DomainExportService } from './services/domain-export.service';
import { DomainImportWizardService } from './services/domain-import-wizard.service';
import { DomainManagementSharedService } from './services/domain-management-shared.service';
import { DomainFileParserService } from './services/domain-file-parser.service';
import { DomainValidatorService } from './services/domain-validator.service';
import { DomainCreationService } from './services/domain-creation.service';
import { ExportSelectedButtonComponent } from './components/export-selected-button/export-selected-button.component';
import { ExportAllButtonComponent } from './components/export-all-button/export-all-button.component';
import { ImportCsvButtonComponent } from './components/import-csv-button/import-csv-button.component';
import { ImportJsonButtonComponent } from './components/import-json-button/import-json-button.component';
import { DomainImportDropdownComponent } from './components/import-dropdown/import-dropdown.component';
import { FormImportWizardComponent } from './forms/import-wizard/import-wizard.component';
import { ImportWizardUploadComponent } from './forms/import-wizard/steps/upload/upload.component';
import { ImportWizardConfigureComponent } from './forms/import-wizard/steps/configure/configure.component';
import { ImportWizardConfirmComponent } from './forms/import-wizard/steps/confirm/confirm.component';
import { ImportWizardProgressComponent } from './forms/import-wizard/steps/progress/progress.component';
import { ImportWizardResultsComponent } from './forms/import-wizard/steps/results/results.component';

@NgModule({
    declarations: [
        ExportSelectedButtonComponent,
        ExportAllButtonComponent,
        ImportJsonButtonComponent,
        ImportCsvButtonComponent,
        DomainImportDropdownComponent,
        FormImportWizardComponent,
        ImportWizardUploadComponent,
        ImportWizardConfigureComponent,
        ImportWizardConfirmComponent,
        ImportWizardProgressComponent,
        ImportWizardResultsComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        TranslateModule,
        LayoutModule,
    ],
    providers: [
        DomainExportService,
        DomainImportWizardService,
        DomainManagementSharedService,
        DomainFileParserService,
        DomainValidatorService,
        DomainCreationService,
    ],
    exports: [
        ExportSelectedButtonComponent,
        ExportAllButtonComponent,
        ImportCsvButtonComponent,
        ImportJsonButtonComponent,
        DomainImportDropdownComponent,
    ],
})
export class DomainManagementModule {}
